<template>
  <div>
    <div class="kqf-card mg10 search-box mt20">
      <el-form
        :inline="true"
        :model="search"
        size="mini"
        class="demo-form-inline"
      >
        <el-form-item label="标题">
          <el-input v-model="search.title" placeholder="标题"></el-input>
        </el-form-item>
        <el-form-item label="分类">
          <select-article-cat
            v-model="search.category_id"
            @input="getList(1)"
          ></select-article-cat>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList(1)">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div
      class="kqf-card mg10 pd10 mt20"
      v-loading="loading"
      style="min-width: 1100px"
    >
      <el-table border :data="datas.list"   height="calc(100vh - 290px)">
        <el-table-column label="ID" width="80" prop="id"></el-table-column>
        <el-table-column label="标题" align="center">
          <template slot-scope="scope">
            <p class="text-over2">{{ scope.row.title }}</p>
          </template>
        </el-table-column>
        <el-table-column label="图片" width="80" align="center">
          <template slot-scope="scope">
            <el-image
              style="width: 30px; height: 30px"
              lazy
              :src="scope.row.image"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column
          label="分类名称"
          prop="category_name"
          align="center"
        ></el-table-column>

        <el-table-column label="是否推荐" align="center">
          <template slot-scope="scope">
            <el-switch
              @input="setOnline(scope.row)"
              :value="scope.row.recommend"
              :active-value="2"
              :inactive-value="1"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column
          label="排序"
          prop="sort"
          align="center"
        ></el-table-column>
        <el-table-column label="创建时间" width="164" align="center">
          <template slot-scope="scope">
            <p>{{ scope.row.create_time }} -- {{ scope.row.create_ip }}</p>
          </template>
        </el-table-column>
        <el-table-column label="是否微信专属" width="120" align="center">
          <template slot-scope="scope">
            <el-switch @input="setIsexclusive(scope.row)" :value="scope.row.exclusive" :active-value="1" :inactive-value="0">
            </el-switch>
          </template>
        </el-table-column>

        <el-table-column label="是否启用" width="100" align="center">
          <template slot-scope="scope">
            <el-switch
              @input="setIsstatus(scope.row)"
              :value="scope.row.status"
              :active-value="1"
              :inactive-value="2"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <router-link
              :to="{ path: '/article/edit', query: { id: scope.row.id } }"
            >
              <el-button icon="el-icon-edit" type="primary" size="mini"
                >编辑</el-button
              >
            </router-link>
            <!-- <el-button
              icon="el-icon-edit"
              type="primary"
              size="medium"
              @click="geteditDatas(scope.row)"
              >编辑</el-button
            > -->

            <el-popconfirm
              style="margin-left: 10px"
              title="这是一段内容确定删除吗？"
              @confirm="handleDelete(scope.row)"
            >
              <el-button
                icon="el-icon-delete"
                type="danger"
                slot="reference"
                size="mini"
                >删除</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <div class="flex space mt10">
        <div>
          <!-- <el-button
            type="primary"
            icon="el-icon-plus"
            size="medium"
            @click="createEnv()"
            >新增文章</el-button
          > -->
           <router-link
              :to="{ path: '/article/create'}"
            >
              <el-button icon="el-icon-edit" type="primary" size="medium"
                >新增文章</el-button
              >
            </router-link>
        </div>
        <div>
          <el-pagination
            @current-change="getList"
            background
            :page-size="datas.limit"
            layout="total, prev, pager, next"
            :total="datas.count"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog width="600px" title="添加文章分类"  :visible.sync="createDialog">
      <el-form label-width="100px" size="small" v-loading="loading">
        <el-form ref="form" :model="form" label-width="80px">
          <el-table-column label="操作" width="190">
            <div class="flex">
              <el-form-item label="标题：" required>
                <el-input
                  v-model="form.title"
                  placeholder="新闻标题，同SEO标题"
                ></el-input>
              </el-form-item>
              <el-form-item label="摘要：" required>
                <el-input
                  v-model="form.abstract"
                  placeholder="新闻摘要"
                ></el-input>
              </el-form-item>
            </div>
          </el-table-column>
          <div class="flex">
            <el-form-item label="关键字：">
              <el-input
                v-model="form.keywords"
                placeholder="SEO 关键字"
              ></el-input>
            </el-form-item>
            <el-form-item label="描述：">
              <el-input
                v-model="form.description"
                placeholder="SEO 描述"
              ></el-input>
            </el-form-item>
          </div>
          <div class="flex">
            <el-form-item label="分类：">
              <select-article-cat
                v-model="form.category_id"
              ></select-article-cat>
            </el-form-item>
            <el-form-item label="排序：" required>
              <el-input-number v-model="form.sort" :min="0"></el-input-number>
            </el-form-item>
          </div>
          <div class="flex">
            <el-form-item label="推荐：" style="width: 50%" required>
              <el-switch
                v-model="form.recommend"
                :active-value="2"
                :inactive-value="1"
              ></el-switch>
            </el-form-item>
            <el-form-item label="启用：" required>
              <el-switch
                v-model="form.status"
                :active-value="1"
                :inactive-value="2"
              ></el-switch>
            </el-form-item>

            <el-form-item label="微信专属：" required>
              <el-switch v-model="form.exclusive" :active-value="1" :inactive-value="0"></el-switch>
            </el-form-item>

          </div>
          <el-form-item label="图片：" required>
            <upload-one w="80px" h="80px" v-model="form.image"></upload-one>
            <!-- <p class="form-tip">建议尺寸 154 * 120 或等比例缩放</p> -->
          </el-form-item>
          <el-form-item label="内容：" required>
            <html-editor v-model="form.content" type="pc"></html-editor>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="medium"
              style="margin: 20px 0 0px 0px"
              @click="createArticle"
              >保存</el-button
            >
          </el-form-item>
        </el-form>
      </el-form>
    </el-dialog>

    <el-dialog width="600px" title="编辑文章分类" :visible.sync="editDialog">
      <el-form label-width="100px" size="small" v-loading="loading">
        <el-form ref="form" :model="form" label-width="80px">
          <el-table-column label="操作" width="190">
            <div class="flex">
              <el-form-item label="标题：" required>
                <el-input
                  v-model="form.title"
                  placeholder="新闻标题，同SEO标题"
                ></el-input>
              </el-form-item>
              <el-form-item label="摘要：" required>
                <el-input
                  v-model="form.abstract"
                  placeholder="新闻摘要"
                ></el-input>
              </el-form-item>
            </div>
          </el-table-column>
          <div class="flex">
            <el-form-item label="关键字：">
              <el-input
                v-model="form.keywords"
                placeholder="SEO 关键字"
              ></el-input>
            </el-form-item>
            <el-form-item label="描述：">
              <el-input
                v-model="form.description"
                placeholder="SEO 描述"
              ></el-input>
            </el-form-item>
          </div>
          <div class="flex">
            <el-form-item label="分类：">
              <select-article-cat
                v-model="form.category_id"
              ></select-article-cat>
            </el-form-item>
            <el-form-item label="排序：" required>
              <el-input-number v-model="form.sort" :min="0"></el-input-number>
            </el-form-item>
          </div>
          <div class="flex">
            <el-form-item label="推荐：" style="width: 50%" required>
              <el-switch
                v-model="form.recommend"
                :active-value="2"
                :inactive-value="1"
              ></el-switch>
            </el-form-item>
            <el-form-item label="启用：" required>
              <el-switch
                v-model="form.status"
                :active-value="1"
                :inactive-value="2"
              ></el-switch>
            </el-form-item>
            <el-form-item label="微信专属：" required>
              <el-switch v-model="form.exclusive" :active-value="1" :inactive-value="0"></el-switch>
            </el-form-item>
          </div>
          <el-form-item label="图片：" required>
            <upload-one w="80px" h="80px" v-model="form.image"></upload-one>
            <!-- <p class="form-tip">建议尺寸 154 * 120 或等比例缩放</p> -->
          </el-form-item>
          <el-form-item label="内容：" required>
            <html-editor v-model="form.content" type="pc"></html-editor>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="medium"
              style="margin: 20px 0 0px 0px"
              @click="editsArticle"
              >保存</el-button
            >
          </el-form-item>
        </el-form>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import UploadOne from "../../components/upload/UploadOne";
import HtmlEditor from "../../components/editer/Editer";
import {
  articleList,
  deleteArticle,
  onlineArticle,
  isstatusArticle,
  createArticle,
  editsArticle,
  getEditData,
  isexclusive,
} from "../../request/api/article/article";
import SelectArticleCat from "./components/SelectArticleCat";
export default {
  components: { SelectArticleCat, UploadOne, HtmlEditor },
  data() {
    return {
      datas: [],
      search: this.getSearch(),
      loading: false,
      createDialog: false,
      editDialog: false,
      category_names: [],
      form: {
        title: "",
        keywords: "",
        abstract: "",
        description: "",
        category_id: '',
        image: "",
        content: "",
        recommend: "",
        introduction_video: "",
        detailed_video: "",
        sort: "",
        status: "",
        exclusive: "",
        id: "",
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    setOnline(row) {
      this.loading = true;
      onlineArticle({ id: row.id })
        .then(() => {
          row.recommend = row.recommend == 2 ? 1 : 2;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    //启用
    setIsstatus(row) {
      this.loading = true;
      isstatusArticle({ id: row.id })
        .then(() => {
          row.status = row.status == 2 ? 1 : 2;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    //是否微信专属
    setIsexclusive(row) {
      this.loading = true;
      isexclusive({ id: row.id })
              .then(() => {
                row.exclusive = row.exclusive == 0 ? 1 : 0;
                this.loading = false;
              })
              .catch(() => {
                this.loading = false;
              });
    },
    getSearch() {
      return {
        title: "",
        category_id: "",
        page: 1,
      };
    },
    getList(page) {
      this.search.page = page;
      this.loading = true;
      articleList({
        page: page,
        title: this.search.title,
        category_id: this.search.category_id,
      })
        .then((res) => {
          this.datas = res;
          // console.log(this.datas);
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onSubmit() {
      this.getList();
    },

    handleChange(category_name) {
      this.formInline.category_id = category_name[1] || category_name[0];
    },

    handleDelete(row) {
      this.loading = true;
      deleteArticle({ id: row.id })
        .then(() => {
          //最后一页无数据 向上翻页
          if (this.datas.list.length <= 1 && this.search.page > 1) {
            this.search.page -= 1;
          }
          this.getList(this.search.page);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 新增文章
    createEnv(row) {
      this.createDialog = true;
      this.createForm = JSON.parse(JSON.stringify(row));

    },

    createArticle() {
      this.loading = true;
      this.createDialog = true;
      createArticle({
        title: this.form.title,
        category_id: this.form.category_id,
        description: this.form.description,
        keywords: this.form.keywords,
        image: this.form.image,
        content: this.form.content,
        abstract: this.form.abstract,
        recommend: this.form.recommend,
        introduction_video: this.form.introduction_video,
        detailed_video: this.form.detailed_video,
        sort: this.form.sort,
        status: this.form.status,
        exclusive: this.form.exclusive,
      })
        .then((res) => {
          this.loading = false;
          this.$message.success("操作成功");
          setTimeout(() => {
            this.getList();
            this.createDialog = false;
          }, 500);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 编辑文章
    geteditDatas(row) {
      this.editDialog = true;
      getEditData({
        id: row.id,
      })
        .then((res) => {
          this.form = res;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    editsArticle() {
      this.loading = true;
      editsArticle({
        id: this.form.id,
        title: this.form.title,
        category_id: this.form.category_id,
        keywords: this.form.keywords,
        description: this.form.description,
        image: this.form.image,
        content: this.form.content,
        abstract: this.form.abstract,
        recommend: this.form.recommend,
        introduction_video: this.form.introduction_video,
        detailed_video: this.form.detailed_video,
        sort: this.form.sort,
        status: this.form.status,
        exclusive: this.form.exclusive,
      })
        .then(() => {
          this.loading = false;
          this.$message.success("操作成功");
          setTimeout(() => {
            this.getList();
            this.editDialog = false
          }, 500);
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style scoped>
</style>